import React, {useEffect, useState} from 'react';
import {UncontrolledAlert} from 'reactstrap';
import {Link} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from '../utils/IntlMessages';
import { translator } from '../utils/Translator';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  hideMessage,
  showAuthLoader,
  userSignIn,
  showAuthMessage
} from '../actions';


import Logo from '../assets/images/logo.png';

//const logo = require("../assets/images/logo.png");

const SignIn = (props) => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const {loader, alertMessage, showMessage, authUser} = useSelector(({auth}) => auth);
  const { translate } = useSelector(({i18n}) => i18n);

  useEffect(() => {
    // if (showMessage) {
    //   setTimeout(() => {
    //     dispatch(hideMessage());
    //   }, 100);
    // }
    if (authUser !== null) {
      props.history.push('/');
    }
  }, [authUser, props.history]);

  const onDismiss = () => dispatch(hideMessage());

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(showAuthLoader());

    if(username.length > 0 && password.length > 0){
      dispatch(userSignIn({username, password}))
    }else{
      dispatch(showAuthMessage("username and password is required"));
    }
  }

  return (
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
      <div className="app-login-main-content">

        <div className="app-logo-content d-flex align-items-center justify-content-center">
          <Link className="logo-lg" to="/" title="Logo">
            <img src={Logo} alt="Logo" title="Logo" style={{width: '100%'}} />
          </Link>
        </div>

        <div className="app-login-content">
          <div className="app-login-header mb-4">
            <h1>{translator(translate.ISA_LogonText, "เข้าสู่ระบบ")} { process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : "" }</h1>
          </div>

          <div className="app-login-form">
            { showMessage && 
              <UncontrolledAlert className="alert-addon-card bg-danger bg-danger text-white shadow-lg" toggle={onDismiss}>
                <span className="icon-addon alert-addon">
                  <i className="zmdi zmdi-alert-triangle jr-fs-2xl"/>
                </span>

                <span className="d-inline-block">{ alertMessage }</span>
              </UncontrolledAlert>
            }
            <form onSubmit={handleSubmit}>
              <fieldset>
                <TextField
                  label={translator(translate.ISA_Username, "ชื่อผู้ใช้งาน")}
                  fullWidth
                  onChange={(e) => setUsername(e.target.value)}
                  defaultValue=""
                  margin="normal"
                  className="mt-1 my-sm-3"
                />
                <TextField
                  type="password"
                  label={translator(translate.ISA_Password, "รหัสผ่าน")}
                  fullWidth
                  onChange={(e) => setPassword(e.target.value)}
                  defaultValue=""
                  margin="normal"
                  className="mt-1 my-sm-3"
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button type="submit" variant="contained" color="primary" disabled={loader}>
                    <IntlMessages id="appModule.signIn"/>
                  </Button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>

      </div>
      { loader && 
          <div className="loader-view">
            <CircularProgress/>
          </div>
      }
    </div>
  );
};


export default SignIn;
